const hours = {
	range: [0, 2],
	isHours: true,
} as const;
const minutes = {
	range: [3, 5],
	isHours: false,
} as const;

function inRange([min, max]: readonly [number, number], value: number) {
	return min <= value && value <= max;
}

function getCursorSection(
	cursorPosition: number,
): { range: readonly [number, number]; isHours: boolean } | null {
	if (inRange(hours.range, cursorPosition)) {
		return hours;
	} else if (inRange(minutes.range, cursorPosition)) {
		return minutes;
	}
	return null;
}

const setSelectionToSection = (e: React.MouseEvent<HTMLElement>) => {
	if (!(e.target instanceof HTMLInputElement)) return;

	const cursorPosition = e.target.selectionStart ?? 0;

	const section = getCursorSection(cursorPosition);

	if (section) {
		e.target.setSelectionRange(...section.range);
	}
};

const handleArrowKeyDown =
	(nudgeTime: (direction: 'up' | 'down', isHours: boolean) => void) =>
	(e: React.KeyboardEvent<HTMLElement>) => {
		if (!(e.target instanceof HTMLInputElement)) return;

		if (
			e.key === 'ArrowUp' ||
			e.key === 'ArrowDown' ||
			e.key === 'ArrowLeft' ||
			e.key === 'ArrowRight'
		) {
			e.preventDefault();

			if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
				const cursorPosition = e.target.selectionStart ?? 0;

				const section = getCursorSection(cursorPosition);

				if (!section) return;

				nudgeTime(e.key === 'ArrowUp' ? 'up' : 'down', section.isHours);
			}
		}
	};

const handleArrowKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
	if (!(e.target instanceof HTMLInputElement)) return;

	if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
		const cursorPosition = e.target.selectionStart ?? 0;

		const section = getCursorSection(cursorPosition);

		if (!section) return;

		if (section.isHours && e.key === 'ArrowRight') {
			e.target.setSelectionRange(...minutes.range);
		} else if (!section.isHours && e.key === 'ArrowLeft') {
			e.target.setSelectionRange(...hours.range);
		}
	}
};

export const timeInputKeyHandlers = (
	nudgeTime: (direction: 'up' | 'down', isHours: boolean) => void,
) => ({
	onClick: setSelectionToSection,
	onKeyDown: handleArrowKeyDown(nudgeTime),
	onKeyUp: handleArrowKeyUp,
});

export { getCursorSection };
